import { ThemeEvents, VariantUpdateEvent } from "@theme/events";

class ProductBadge extends HTMLElement {
  connectedCallback() {
    const closestSection = this.closest(".shopify-section, dialog");
    if (!closestSection) return;
    closestSection.addEventListener(ThemeEvents.variantUpdate, this.updateBadge);
  }

  disconnectedCallback() {
    const closestSection = this.closest(".shopify-section, dialog");
    if (!closestSection) return;
    closestSection.removeEventListener(ThemeEvents.variantUpdate, this.updateBadge);
  }

  /**
   * Updates the badge.
   * @param {VariantUpdateEvent} event - The variant update event.
   */
  updateBadge = (event) => {
    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    } else if (
      event.target instanceof HTMLElement &&
      event.target.dataset.productId !== this.dataset.productId
    ) {
      return;
    }

    // 선택 미완결(KS: 사이즈 미선택)이면 대표 variant의 뱃지(Sold out/Sale 등)로
    // 덮어쓰지 않는다. 고르지 않은 변형 기준 뱃지 오표시를 막는다.
    // (undefined=legacy 생산자는 기존 동작 유지)
    if (event.detail.data.selectionComplete === false) return;

    // Skip if no HTML (cache hit - will sync via background fetch)
    if (!event.detail.data.html) return;

    // Find the correct product-badge in HTML by matching productId
    // This prevents taking badge from wrong product (e.g. recommendations)
    const productId = this.dataset.productId;
    let newBadge = null;

    if (productId) {
      // Find all product-badge elements and match by productId
      const allBadges = event.detail.data.html.querySelectorAll("product-badge");
      for (const badge of allBadges) {
        if (badge.dataset.productId === productId) {
          newBadge = badge.querySelector('[ref="badgesContainer"]');
          break;
        }
      }
    }

    // Fallback: if no productId match, use first badge (for single product pages)
    if (!newBadge) {
      const fallbackBadge = event.detail.data.html.querySelector("product-badge");
      newBadge = fallbackBadge?.querySelector('[ref="badgesContainer"]');
    }

    const currentBadge = this.querySelector('[ref="badgesContainer"]');

    if (!newBadge || !currentBadge) return;

    if (currentBadge.innerHTML !== newBadge.innerHTML) {
      currentBadge.replaceWith(newBadge);
    }
  };
}

if (!customElements.get("product-badge")) {
  customElements.define("product-badge", ProductBadge);
}
